import { safeParse } from "@moodys/mdc-toolbox.utils.json-helpers";
export const getOktaTokensFromLocalStorage = () => {
    const oktaTokenStorage = localStorage.getItem("okta-token-storage");
    if (!oktaTokenStorage)
        return undefined;
    // Do not think we gain much from typing the full structure from localStorage
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parsedStorage = safeParse(oktaTokenStorage);
    const accessToken = parsedStorage?.accessToken?.accessToken;
    if (!accessToken)
        return undefined;
    return {
        accessToken,
    };
};
export const getMapTokensFromLocalStorage = () => {
    const mapTokenStorage = localStorage.getItem("ma-sso-tokens");
    if (!mapTokenStorage)
        return undefined;
    // Do not think we gain much from typing the full structure from localStorage
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parsedStorage = safeParse(mapTokenStorage);
    const accessToken = parsedStorage?.accessToken;
    if (!accessToken)
        return undefined;
    return {
        accessToken,
    };
};
//# sourceMappingURL=token.utils.js.map